import Feature from "src/js/stores/user/Feature";
import { ConstraintsCategory } from "../../Constraints/types";
import { Layer, LayerGroup } from "../types";
import { EnvironmentalPermitsSummaryLayerType } from "../layer_types/EnvironmentPermitsLayerType";
import { EnvironmentalPermitsListSubTitle } from "../layer_types/EnvironmentPermitsLayerType/components/EnvironmentalPermitsListSubTitle";
import { PermitsLayerType } from "../layer_types/PermitsLayerType/PermitsLayerType";

export const ENVIRONMENTAL_PERMITS: Layer = {
  id: ConstraintsCategory.ENVIRONMENTAL_PERMITS,
  layerType: PermitsLayerType,
  requiredFeatureAccess: [Feature.buildingPermits],
  group: LayerGroup.PERMITS,
  icon: "lt-leaf-line",
  description: "Dredging, filling, or construction near surface waters",
  toggleable: true,
  hideByDefault: true,
  title: "Environmental permits",
  layerConfig: {
    components: {
      DesignationList: {
        SubTitle: EnvironmentalPermitsListSubTitle,
      },
    },
    attributesToLoad: ["application_submission_date"],
    rootCategory: ConstraintsCategory.ENVIRONMENTAL_PERMITS,
    categorySchema: [
      { key: "environmental_permits_approved" },
      { key: "environmental_permits_pending" },
      { key: "environmental_permits_withdrawn" },
      { key: "environmental_permits_rejected" },
      { key: "environmental_permits_unknown" },
    ],
  },
};

export const ENVIRONMENTAL_PERMITS_INSIGHTS_SUMMARY: Layer = {
  ...ENVIRONMENTAL_PERMITS,
  layerType: EnvironmentalPermitsSummaryLayerType,
  requiredFeatureAccess: [Feature.insightsSummary],
};
